import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IPrepaidApplicationValidationFormMeta {
  idBank: FormInputMeta,
  nameBank: FormInputMeta,

  client: FormInputMeta,
  agency: FormInputMeta,
  prepaidProgram: FormInputMeta,
  cardProgram: FormInputMeta,
  ADIR: FormInputMeta,
  // Schema
  schema: any,
}

const PrepaidApplicationValidationFormMeta = {} as IPrepaidApplicationValidationFormMeta;

PrepaidApplicationValidationFormMeta.idBank = {
  name: 'idBank',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required(),
};

PrepaidApplicationValidationFormMeta.nameBank = {
  name: 'nameBank',
  type: 'text',
  label: 'Raison sociale',
  placeholder: '',
  validation: yup.string().required(),
};


PrepaidApplicationValidationFormMeta.client = {
  name: 'client',
  type: 'text',
  label: 'Client',
  placeholder: '',
  validation: yup.string().required(),
};

PrepaidApplicationValidationFormMeta.agency = {
  name: 'agency',
  type: 'text',
  label: 'Agence',
  placeholder: '',
  validation: yup.string().required(),
};
PrepaidApplicationValidationFormMeta.prepaidProgram = {
  name: 'madeBy',
  type: 'text',
  label: 'Programme prépayé',
  placeholder: '',
  validation: yup.string().required(),
};
PrepaidApplicationValidationFormMeta.cardProgram = {
  name: 'cardProgram',
  type: 'text',
  label: 'Programme carte',
  placeholder: '',
  validation: yup.string().required(),
};
PrepaidApplicationValidationFormMeta.ADIR = {
  name: 'ADIR',
  type: 'radio',
  label: 'A.D.I.R.',
  options: [
    {
      label: 'A',
      value: 'a',
    },
    {
      label: 'D',
      value: 'd',
    },
    {
      label: 'I',
      value: 'i',
    },
    {
      label: 'R',
      value: 'r',
    },
  ],
  validation: yup.string().required(),
};


PrepaidApplicationValidationFormMeta.schema = yup.object().shape(getValidationSchema(PrepaidApplicationValidationFormMeta));

export default PrepaidApplicationValidationFormMeta;